import { useState } from "react";
import { v4 as uuid } from 'uuid';
import saveFile from "../../hooks/SaveFile";
import { useHistory } from "react-router-dom";
import firebase from "../../firebase/compat";
import Location from "../../hooks/Location"
import spinner from '../../images/spinner-ripple.svg'
import Hostname from '../../hooks/Hostname'
import { db } from "../../firebase/config";
import UploadProgress from "../../components/common/UploadProgress";

const CreateAccount = () => {
    // State
    const [compagny, setCompagny] = useState('')
    const [logo, setLogo] = useState('https://firebasestorage.googleapis.com/v0/b/deccos-app.appspot.com/o/Logos%2FLOGO-logo.png?alt=media&token=2785407c-d390-4ddd-a7c8-db38d1b6a0ba')
    const [logoMeta, setLogoMeta] = useState(null)
    const [logoProgress, setLogoProgress] = useState(0)
    const [logoError, setLogoError] = useState(null)
    const [website, setWebsite] = useState('')
    const [loading, setLoading] = useState(false)

    // Hooks
    const history = useHistory();
    const trialType = Location()[2]
     const host = Hostname()

    // Handlers
    const compagnyHandler = (e) => {
        setCompagny(e.target.value)
    }

    const logoHandler = (e) => {
        setLogoError(null)
        // Eigen map: deze upload gebeurt vóórdat het account bestaat, dus zonder
        // login. In de hoofdmap zou een gelijknamig bestand overschreven worden.
        // AI-CONTEXT: See docs/inbox.md #122
        saveFile(e, setLogo, setLogoMeta, setLogoProgress, (err) => setLogoError(err?.message || 'Upload mislukt'), 'signup-logos')
    }

    // Email to Deccos
    const email = () => {
        db.collection("Email").doc().set({
            to: 'info@deccos.nl',
            from: 'info@deccos.nl',
            replyTo: `${host.Name}`,
            message: {
            subject: `Nieuwe omgeving aangemaakt op Deccos`,
            html: `Er is een nieuwe omgeving aangemaakt op Deccos: </br></br>
                ${compagny} <br><br>
                
                Vriendelijke groet, </br></br>
                Team ${host.Name} </br></br>
                `,
            Emailadres: 'info@deccos.nl',
            Type: "Nieuw account mail"
              }     
          });
    }

    const createAccount = async () => {

        setLoading(true)

        const id = uuid()

        const createProjectAccount = firebase.functions().httpsCallable('createProjectAccount')  

        const data = {
            compagny: compagny,
            logo: logo,
            trialType: trialType,
            ImpactManager: 'Deccos',
            Parent: null,
            Subscription: 'trial',
            CompagnyId: id,
            Website: website,
            onboarding: true,
            subscriptionType: 'free',
        }

        try {
            const result = await createProjectAccount({data: data})

            if(result.data === 'success') {
                setLoading(false)
                email()
                history.push(`/${id}/Register`)
            }
        } catch (err) {
            console.error('createAccount createProjectAccount error', err)
            setLoading(false)
            alert(`Er is iets mis gegaan: ${err.message || 'onbekende fout'}. Neem contact op met Deccos via info@deccos.nl`)
        }
        
      };

  return (
    <div className="login-container" id='create-account-container'>
        <h2>Stap 1 van 2</h2>
        <h1>Creëer Deccos Impact Software bedrijfsprofiel</h1>
        <p>Om met Deccos Impact Software aan de slag te gaan heb je om te beginnen een bedrijfsprofiel nodig.</p>
        <div className="create-account-input-container">
            <h2>Bedrijfsnaam*</h2>
            <input type="text" placeholder="Schrijf hier de naam van je organisatie" onChange={compagnyHandler}/>
        </div>
        <div className="create-account-input-container">
            <h2>Logo</h2>
            <img src={logo} id='create-account-dummy-logo' alt="logo" width={150} height={80} />
            <input
                type="file"
                onChange={logoHandler}
                disabled={logoProgress > 0 && logoProgress < 100}
            />
            <UploadProgress
                progress={logoProgress}
                error={logoError}
                fileName={logoMeta?.name}
            />
        </div>
        <div className="create-account-input-container">
            <h2>Website</h2>
            <input type="text" placeholder="Schrijf hier de website van je organisatie" onChange={(e) => setWebsite(e.target.value)}/>
        </div>
        <div id='subscribe-button-container'>
            <button style={{display: loading ? 'none' : 'block'}} onClick={createAccount}>Creëer bedrijfsprofiel</button>
            <img style={{display: loading ? 'block' : 'none'}} src={spinner} alt="" />
            <p>Je abonnement blijft gratis zolang jij dat wilt.</p>
        </div>
        <p id='mandetory-notice'>* verplicht</p>
    </div>
  )
}

export default CreateAccount